<!--begin::Subheader-->
<div class="subheader py-2 py-lg-6 m-0 margin-res" [ngClass]="subheaderCSSClasses" id="kt_subheader">

    <div [ngClass]="subheaderContainerCSSClasses"
         class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
        <!--begin::Info-->
        <div class="d-flex align-items-center flex-wrap mr-1">
            <ng-container *ngIf="subheaderMobileToggle">
                <!--begin::Mobile Toggle-->
                <button class="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
                        id="kt_subheader_mobile_toggle">
                    <span></span>
                </button>
                <!--end::Mobile Toggle-->
            </ng-container>
        </div>
        <!--end::Info-->

        <!--Blue ToolBar-->
        <div class="d-flex align-items-center">
            <ng-container *ngIf="showWorkTracker">

                <!--Toggle Work From Home or Work from Office-->
                <div class="d-flex align-items-center work-from-home-switch mr-6"
                     *ngIf="workShiftEnded && (userRolls | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_user'])">
                    <div class="d-flex flex-row align-items-center">
                        <i class="fa fa-building mr-2"
                           placement="bottom" ngbTooltip="Office"></i>
                        <label class="my-switch">
                            <input type="checkbox" name="workFromHome" [formControl]="workFromHome">
                            <span class="slider"></span>
                        </label>
                        <i class="fa fa-laptop-house ml-2" placement="bottom" ngbTooltip="Home"></i>
                    </div>
                </div>

                <!--Start Work Btn-->
                <button type="button" class="start-work-btn font-weight-bold"
                        *ngIf="workShiftEnded && (userRolls | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_user'])"
                        (click)="workConfirmModal(startWorkModal)">
                    Start Work
                </button>

                <!--End Work Btn-->
                <button type="button" class="end-work-btn font-weight-bold"
                        *ngIf="!workShiftEnded && (userRolls | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_user'])"
                        (click)="workConfirmModal(endWorkModal)" placement="bottom"
                        ngbTooltip="You clocked in at: {{startWorkingDate | date: 'H:mm'}}">
                    End Work
                </button>
            </ng-container>


            <!--Show / Hide - Work Tracker-->
            <button type="button" class="show-work-tracker-btn font-weight-bold ml-4" (click)="showWorkTrackerTest()"
                    *ngIf="userRolls | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_user']"
                    placement="bottom" ngbTooltip="{{showWorkTracker ? 'Hide work tracker' : 'Show work tracker'}}">
                <i class="fas fa-eye" *ngIf="!showWorkTracker"></i>
                <i class="far fa-eye-slash" *ngIf="showWorkTracker"></i>
            </button>

            <span class="mx-4 text-white d-none d-md-block"
                  *ngIf="userRolls | roleChecker : ['ROLE_super_admin', 'ROLE_admin', 'ROLE_user']">|</span>

            <!--Current Date-->
            <ng-container *ngIf="subheaderDisplayDateRangePicker">
                <span class="text-white font-weight-normal custom-font d-none d-md-block" style="font-size: 16px">
                    <span class="font-weight-boldest text-white">{{actualDate  | date: 'EEE, MMM d, y - h:mm a'}}</span>
                </span>
            </ng-container>

        </div>

    </div>
</div>
<!--end::Subheader-->


<ng-template #startWorkModal let-c="close">
    <div class="modal-header">
        <h4 class="modal-title text-white" translate="WORK_TRACKER.START" style="font-size: 24px"></h4>
    </div>
    <div class="modal-body d-flex justify-content-start">
        <p class="m-0" translate="WORK_TRACKER.START_CONFIRM"></p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn-default btn-red mr-5 border-0 flex-row-reverse" (click)="c()"
                translate="GENERAL.NO">
            <span class="fas fa-times mr-3"></span>
        </button>

        <button type="button" class="btn-default btn-main border-0 flex-row-reverse" (click)="startWork(); c()"
                translate="GENERAL.YES">
            <span class="fas fa-save mr-3"></span>
        </button>
    </div>
</ng-template>

<ng-template #endWorkModal let-c="close">
    <div class="modal-header">
        <h4 class="modal-title text-white" translate="WORK_TRACKER.END" style="font-size: 24px"></h4>
    </div>
    <div class="modal-body d-flex justify-content-start">
        <p class="m-0" translate="WORK_TRACKER.END_CONFIRM"></p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn-default btn-red mr-5 border-0 flex-row-reverse" (click)="c()"
                translate="GENERAL.NO">
            <span class="fas fa-times mr-3"></span>
        </button>

        <button type="button" class="btn-default btn-main border-0 flex-row-reverse"
                (click)="endWork(); c()" translate="GENERAL.YES">
            <span class="fas fa-save mr-3"></span>
        </button>
    </div>
</ng-template>
